import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

export default class extends Controller {

  static targets = [ "expandAllButton", "collapseAllButton" ]

  // Reconcile the controls from the live DOM on every collapse transition
  // (events bubble to the controller root) rather than counting a fixed set
  // of expected events. An interrupted transition or an accordion item
  // removed mid-animation then cannot leave the buttons stuck out of sync.
  connect() {
    this.boundSync = () => this.#syncControls()
    this.element.addEventListener("shown.bs.collapse", this.boundSync)
    this.element.addEventListener("hidden.bs.collapse", this.boundSync)
    this.#syncControls()
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.collapse", this.boundSync)
    this.element.removeEventListener("hidden.bs.collapse", this.boundSync)
  }

  expandAll() {
    this.element.querySelectorAll(".accordion-collapse:not(.show)").forEach(el => {
      Collapse.getOrCreateInstance(el).show()
    })
    this.#syncControls()
  }

  collapseAll() {
    this.element.querySelectorAll(".accordion-collapse.show").forEach(el => {
      Collapse.getOrCreateInstance(el).hide()
    })
    this.#syncControls()
  }

  #syncControls() {
    const total = this.element.querySelectorAll(".accordion-collapse").length
    const expanded = this.element.querySelectorAll(".accordion-collapse.show").length
    const allExpanded = total > 0 && expanded === total

    this.expandAllButtonTarget.hidden = allExpanded
    this.collapseAllButtonTarget.hidden = !allExpanded
  }
}
